import { useContext, useState } from 'react';
import moment from 'moment';

import Loading from 'Lib/components/common/Loading';
import EmailChipField from 'Lib/components/form/EmailChipField';
import TextField from 'Lib/components/form/TextField';
import SidebarContext from 'Lib/contexts/SidebarContext';
import useApi from 'Lib/hooks/useApi';
import useNotify from 'Lib/hooks/useNotify';
import isEmpty from 'Lib/utilities/isEmpty';

function ComposeForm(props) {
    const { workOrder } = props;
    const {
        components: { Attachments, EmailTemplateField, EmailToField, WysiwygField },
        apis
    } = useContext(SidebarContext);

    const { toastError } = useNotify();
    const [attachments, setAttachments] = useState([]);

    const [message, setMessage] = useState('');
    const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
    const [isRendering, setIsRendering] = useState(false);

    const handleRenderEmailTemplate = useApi(apis.renderEmailTemplate);

    const handleEmailTemplateChange = (option, form) => {
        if (option) {
            const emailTemplateID = option.value;
            form.setFieldValue('inputs', {});

            handleRender(form, emailTemplateID);
        } else {
            setMessage(null);
            setAttachments([]);
            form.setFieldValue('subject', '');
        }
    };

    const handleRender = (form, emailTemplateID) => {
        const { objectID, templateObjectTypeID } = props;
        const data = {
            templateObjectTypeID,
            objectID,
            inputs: form ? form.values.inputs : {}
        };

        setIsRendering(true);
        setIsLoadingTemplate(true);

        handleRenderEmailTemplate(emailTemplateID, data, { includes: 'attachments' })
            .then(response => {
                setAttachments(response.data.attachments);
                setMessage(response.data.emailTemplate.body + '');

                form?.setFieldValue('subject', response.data.emailTemplate.subject);
                form?.setFieldValue('message', response.data.emailTemplate.body + '');
                setIsLoadingTemplate(false);
                setIsRendering(false);
            })
            .catch(error => {
                toastError(error);
                setIsLoadingTemplate(false);
                setIsRendering(false);
            });
    };

    const renderForm = () => {
        const { objectID, fromMessage, renderAttachments, objectTypeID, templateObjectTypeID, recipients = [], form } = props;

        return (
            <div>
                {!isEmpty(recipients) ? (
                    recipients.map((recipient, index) => (
                        <div className="chip" key={index}>
                            {recipient.name ? recipient.name : recipient.recipient}
                        </div>
                    ))
                ) : fromMessage ? (
                    <div>To: {fromMessage.from}</div>
                ) : (
                    <EmailToField {...props} objectTypeID={objectTypeID} objectID={objectID} form={form} id="recipients" name="recipients" />
                )}
                <EmailChipField label="Additional Recipients" id="additionalRecipients" name="additionalRecipients" isMulti={true} />
                <EmailChipField label="BCC" name="bcc" id="bcc" isMulti={true} />
                <hr />

                {!isEmpty(templateObjectTypeID) && (
                    <EmailTemplateField
                        label="Email Template"
                        id="emailTemplateID"
                        name="email.emailTemplateID"
                        templateObjectTypeID={templateObjectTypeID}
                        onChange={handleEmailTemplateChange}
                    />
                )}
                <TextField label="Subject" name="subject" id="subject" isRequired />
                {isLoadingTemplate ? <Loading singleLoader={true} /> : <WysiwygField value={message} form={form} label="Message" name="message" id="message" />}

                <hr />
                <h4>Attachments</h4>
                {renderAttachments ? (
                    renderAttachments()
                ) : (
                    <>
                        {workOrder && (
                            <li style={{ listStyle: 'none', padding: '0 10px' }}>
                                <i className="fa fa-file-pdf-o" aria-hidden="true" /> Work-Order-{workOrder.workOrderNumber}-{moment().format('YYYYMMDD')}
                                .pdf
                            </li>
                        )}
                        <Attachments form={form} attachments={attachments} />
                    </>
                )}
            </div>
        );
    };

    return renderForm();
}

export default ComposeForm;
